import React from 'react';
import './style.css'
class Pagination extends React.Component {

  componentWillReceiveProps = (props, state) => {
    const pageSize = Number(props.pageSize)
    if (pageSize) {
      this.setState({
        pageSize,
        pages: Math.ceil(props.totalEntries / pageSize),
        currentPage: props.activePage
      })
    }
    else {
      this.setState({
        pages: Math.ceil(props.totalEntries / this.state.pageSize),
        currentPage: props.activePage
      })
    }
  }

  handlePrevious = () => {
    let currentPage = this.state.currentPage > 0 ? this.state.currentPage - 1 : 0;
    this.setState({
      currentPage
    })
    if (this.props.handlePrevious) {
      this.props.handlePrevious(currentPage)
    }
  }

  handleNext = () => {
    let currentPage = this.state.currentPage < this.state.pages ? this.state.currentPage + 1 : this.state.pages;
    this.setState({
      currentPage
    })
    if (this.props.handleNext) {
      this.props.handleNext(currentPage)
    }
  }

  render() {
    const total = this.props.totalEntries
    return (
      <div>
        {total !== 0 ?
          <div className="pagination-container">
            <span className="pagination pr-3" >Showing records {this.state.currentPage === 1 ? 1 : (this.state.currentPage - 1) * this.state.pageSize + 1} to {this.state.currentPage === this.state.pages ? this.props.totalEntries : this.state.currentPage * this.state.pageSize} of a total of {this.props.totalEntries} entries</span>
            <div className="pl-3">
              <button disabled={this.state.currentPage === 1} onClick={this.handlePrevious} className="pagination mr-1" > &#10094;</button>
              <button disabled className="pagination active-page"><span>{this.state.currentPage}</span></button>
              <span className="pagination ml-2">/</span>
              <span className="pagination">{this.state.pages}</span>
              <button disabled={this.state.currentPage === this.state.pages} onClick={this.handleNext} className="pagination ml-2" >&#10095;</button>
            </div>
          </div>
          : null}

      </div>
    );
  }
}

export default Pagination;